<template>
  <div
    class="complete-cart"
    :class="{'is-loading': !stateCartTotalPrice}">

    <span
      v-if="!stateCartTotalPrice"
      class="complete-cart__loading">
      <i class="fas fa-spinner fa-spin"></i>
    </span>

    <template v-else>
      <ul class="complete-cart__list">
        <li
          v-for="(item, name) in itemsSort" :key="item.id"
          class="complete-cart__item">
          <span class="complete-cart__name">{{ item.name }}</span>
          <span v-show="item.priceIncTax" class="complete-cart__price">
            <span class="complete-cart__num">{{ item.priceIncTax | price }}</span>
            <span class="complete-cart__jpy">円</span>
          </span>
          <div v-show="item.priceIncTax" class="complete-cart__line"></div>
        </li>
      </ul>

      <div class="complete-cart__total">
        <div class="complete-cart__quantity">
          <span class="complete-cart__quantity__title">商品点数</span>
          <div class="complete-cart__quantity__value">
            <span class="complete-cart__quantity__num">{{ quantity }}</span>
            <span class="complete-cart__quantity__unit">点</span>
          </div>
        </div>
        <div class="complete-cart__total-price">
          <div class="complete-cart__total-price__title">合計金額</div>
          <div class="complete-cart__total-price__price">
            <span class="complete-cart__total-price__num">{{ stateCartTotalPrice }}</span>
            <span class="complete-cart__total-price__jpy">円</span>
            <span class="complete-cart__total-price__tax">（税込）</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>



<script>
import { mapState } from 'vuex'

export default {
  components: {
    'v-prev-dialog': require('@/components/prev-dialog.vue').default,
  },
  computed: {
    ...mapState({
      stateCartItems: state => state.cart.items,
      stateCartTotalPrice: state => state.cart.totalPrice,
      quantity () {
        let num = 0
        for(let key in this.stateCartItems) {
          if (this.stateCartItems[key].priceIncTax) {
            num = num + 1
          }
        }
        return num
      },
    }),
    itemsSort() {
      let val = JSON.parse(JSON.stringify(this.stateCartItems))
      let sorted = {}
      let array = []

      Object.keys(val).forEach((key) => {
        if (val.hasOwnProperty(key)) {
          array.push(key)
        }
      })

      array.sort((a, b) => {
        a = Number(val[a].page.order)
        b = Number(val[b].page.order)

        if(a < b){
          return -1
        }else if(a > b){
          return 1
        }
        return 0;
      })

      for (let i=0; i<array.length; i++) {
        sorted[array[i]] = this.stateCartItems[array[i]]
      }

      return sorted
    },
  },
  data() {
    return {
      dialog: {
        state: false,
      }
    }
  },
  methods: {
    warningDialog(item) {
      if (Number(this.$route.params.order) === Number(item.page.order)) {
        return
      } else if (Number(this.$route.params.order) < 3) {
        this.$router.push({
          path: this.config.path.root + '/step/sizes/1',
          query: '',
        })
      } else {
        this.$set(this.dialog, 'state', true)
      }
    },
  },
  filters: {
    price(val) {
      if (!val) return

      val = String(val)
      val = val.replace(/,/g, '')
      val = Number(val)
      val = val.toLocaleString()
      val = val.toString()

      return val
    },
  },
}
</script>



<style lang="scss">
.complete-cart {
  position: relative;
  border-radius: 4px;
  border: 1px solid $oc-gray-3;
  background-color: #faf8f7;
  padding: 24px 16px;
  &.is-loading {
    height: 88px;
  }

  &__loading {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &__list {
  }
  &__item {
    position: relative;
    clear: both;
    font-size: 12px;
    color: $oc-gray-9;
    padding: 4px 12px;
  }
  &__name {
    position: relative;
    z-index: 1;
    background-color: #faf8f7;
    padding-right: 20px;
  }
  &__price {
    position: relative;
    z-index: 1;
    float: right;
    background-color: #faf8f7;
    padding-left: 20px;
  }
  &__num {
  }
  &__jpy {
    margin-left: 3px;
  }
  &__line {
    position: absolute;
    top: 50%;
    left: 12px;
    z-index: 0;
    border-top: 2px dotted $oc-gray-5;
    width: calc(100% - 24px);
    height: 0;
  }

  &__total {
  }
  &__quantity {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    padding: 4px 12px;
    &__title {
      font-size: 13px;
      letter-spacing: 0.075em;
    }
    &__value {
    }
    &__num {
      font-size: 15px;
    }
    &__unit {
      font-size: 12px;
      margin-left: 2px;
    }
  }
  &__total-price {
    display: flex;
    justify-content: space-between;
    padding: 4px 12px;
    &__title {
      display: flex;
      align-items: flex-end;
      font-size: 16px;
    }
    &__price {
      margin-right: -5px;
    }
    &__num {
      font-size: 20px;
      font-weight: bold;
    }
    &__jpy {
      margin-left: 4px;
    }
    &__tax {
      font-size: 11px;
    }
  }
}
</style>
